import styled from 'styled-components'

export const TagWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 0;
	justify-content: flex-start;
	justify-items: center;
	align-items: center;
	align-content: center;

	& > span {
		padding: 1px 2px;
		margin: 2px 2px;
		flex: 1;
		text-align: center;
	}
`
